






























































































































import { GeneralMixin } from "@/mixins/general-mixin";
import mixins from "vue-typed-mixins";
import DateModal from "../date-modal.vue";
import solidButton from "../general/solid-button.vue";

export default mixins(GeneralMixin).extend({
  components: { solidButton, DateModal },
  name: "EquipmentsList",
  props: ["cardTitle", "roughEdges", "monitorInfo"],
});
